import React from 'react';
import { IonItem, IonLabel } from '@ionic/react';
import SectionCard from '@/components/SectionCard';
import { ActionGuard } from '@/components/ActionGuard';
import { ActionGuardContainer } from '@/components/ActionGuardContainer';
import { ACTIONS, RESOURCES } from '@/contexts/CasbinContext';

interface ChangesLinkBlockProps {
  topicId: string;
  /** Whether this session has logged any mutations for the topic. */
  hasMutations: boolean;
}

const rowStyle: React.CSSProperties = {
  fontSize: '0.875rem',
  color: 'var(--ion-color-medium)',
  whiteSpace: 'normal',
  margin: 0,
};

/**
 * Links to the change-history subpage when the manager has made edits this
 * session. "Recent changes" names the card, so the row itself carries only the
 * sentence describing what the subpage offers — which differs by permission:
 * only users who can share the topic are promised the sharing half (#418), and
 * everyone else gets the review-only wording rather than a blank row.
 */
const ChangesLinkBlock: React.FC<ChangesLinkBlockProps> = ({
  topicId,
  hasMutations,
}) => {
  if (!hasMutations) return null;
  return (
    <SectionCard title="Recent changes">
      <IonItem
        button
        detail
        lines="none"
        routerLink={`/topics/${encodeURIComponent(topicId)}/changes`}
        data-testid="topic-changes-link"
      >
        <IonLabel>
          {/* Session-only for now — this lists only changes made during the
              current session. Once #417 persists topic deltas for the
              topic's lifetime, retitle the card to
              `Changes since listed on ${formatDate(topic?.createdAt)}`. */}
          <ActionGuardContainer>
            <ActionGuard
              disableMode="hidden"
              action={ACTIONS.SHARE}
              resource={RESOURCES.TOPICS}
              resourceId={topicId}
              guardedElem={
                <p data-testid="topic-changes-share-subtitle" style={rowStyle}>
                  Review &amp; share updates with people previously messaged
                </p>
              }
              fallbackElem={<p style={rowStyle}>Review the updates made</p>}
            />
          </ActionGuardContainer>
        </IonLabel>
      </IonItem>
    </SectionCard>
  );
};

export default ChangesLinkBlock;
